import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPup } from './pages'

type TIdToPageMapWoofzPpp = Record<PageIdWoofzPup, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PUP: TIdToPageMapWoofzPpp = {
  [PageIdWoofzPup.DOG_AGE_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/DogAge').then((m) => ({
        default: m.DogAge,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup/pages/questions/DogAge'),
  },
  [PageIdWoofzPup.DOG_OWNER_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/DogOwnerQuestion').then(
        (m) => ({
          default: m.DogOwnerQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/DogOwnerQuestion'),
  },
  [PageIdWoofzPup.TRAINING_COMMANDS_PUP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup/pages/questions/BasicTrainingCommands'
      ).then((m) => ({
        default: m.BasicTrainingCommands,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/BasicTrainingCommands'),
  },
  [PageIdWoofzPup.URGE_PAGE_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup/pages/urge/UrgePage'),
  },
  [PageIdWoofzPup.DOG_BREED_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/DogBreedQuestion').then(
        (m) => ({
          default: m.DogBreedQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/DogBreedQuestion'),
  },
  [PageIdWoofzPup.FACING_CHALLENGES_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/FacingChallenges').then(
        (m) => ({
          default: m.FacingChallenges,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/FacingChallenges'),
  },
  [PageIdWoofzPup.FACING_CHALLENGES_2_PUP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup/pages/questions/FacingChallengesVersion2'
      ).then((m) => ({
        default: m.FacingChallengesVersion2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup/pages/questions/FacingChallengesVersion2'
      ),
  },
  [PageIdWoofzPup.BEHAVIOR_FREQUENCY_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/BehaviorFrequency').then(
        (m) => ({
          default: m.BehaviorFrequency,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/BehaviorFrequency'),
  },
  [PageIdWoofzPup.URGE_PROGRAM_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/urge/UrgeProgram').then((m) => ({
        default: m.UrgeProgram,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzPup.BEHAVIOR_FEELINGS_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/BehaviorFeelings').then(
        (m) => ({
          default: m.BehaviorFeelings,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/BehaviorFeelings'),
  },
  [PageIdWoofzPup.FIX_BEHAVIOR_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/FixDogBehavior').then(
        (m) => ({
          default: m.FixDogBehavior,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/FixDogBehavior'),
  },
  [PageIdWoofzPup.URGE_PAGE_4_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzPup.COMMANDS_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/DogCommands'),
  },
  [PageIdWoofzPup.PARENT_GOAL_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/GoalQuestion').then(
        (m) => ({
          default: m.GoalQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/GoalQuestion'),
  },
  [PageIdWoofzPup.TRAINING_PLACE_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/TrainingPlace').then(
        (m) => ({
          default: m.TrainingPlace,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/TrainingPlace'),
  },
  [PageIdWoofzPup.TRAINING_FREQUENCY_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/questions/TimeQuestion').then(
        (m) => ({
          default: m.TimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/questions/TimeQuestion'),
  },
  [PageIdWoofzPup.URGE_PAGE_5_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/urge/UrgePageVariant5'),
  },
  [PageIdWoofzPup.PREPARE_FLOW_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/prepare-flow/PrepareFlowPpp').then(
        (m) => ({
          default: m.PrepareFlowPpp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/prepare-flow/PrepareFlowPpp'),
  },
  [PageIdWoofzPup.EMAIL_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/email/EmailPpp').then((m) => ({
        default: m.EmailPpp,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup/pages/email/EmailPpp'),
  },
  [PageIdWoofzPup.NEWSLETTER_URGE_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_pup/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzPup.LAST_CHANCE_OFFER_PUP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup/pages/last-chance-offer/LastChanceOfferPpp'
      ).then((m) => ({
        default: m.LastChanceOfferPpp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup/pages/last-chance-offer/LastChanceOfferPpp'
      ),
  },
  [PageIdWoofzPup.SUBSCRIPTIONS_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/subscriptions/Subscriptions').then(
        (m) => ({
          default: m.Subscriptions,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzPup.CHAT_UPSELL_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzPup.UPSELL_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup/pages/upsell/Upsell'),
  },
  [PageIdWoofzPup.UPSELL_FEEDING_GUIDE_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzPup.UPSELL_EMOTIONAL_SUPPORT_PUP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzPup.DOWNLOAD_PUP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzPup.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
